<template>
	<div class="about">
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item>{{title}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="title">
						<ul>
							<li @click="selItem(item)" 
							:class="sel3===item.name?'active':''" 
							v-for="(item,index) in navlist"
							:key="index" >
							{{item.title}}
							</li>
						</ul>
					</div>
					<router-view/>		
					
				</div>
				
			</div>
			
		
	</div>
</template>

<script>
	
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'about',
				path:'',
				banner:'',
				navlist: [
							{
								title: '公司简介',
								name: 'introduce',
								rou: '/About/'
							},
							{
								title: '公司文化',
								name: 'cultrue',
								rou: '/About/Culture'
							},
							{
								title: '荣誉资质',
								name: 'honor',
								rou: '/About/Honor'
							},
						
				],
				sel3:'introduce',
				title:'公司简介',
				sel:''
			}
		},
		methods:{
			getItem(){
				var url = this.$route.path;
				var regstr = '/About/';
				var str = url.replace(regstr, '');
				if(str == ''){
					this.sel3 = 'introduce';
					this.title = '公司简介';
				}else if(str == 'Culture'){
					this.sel3 = 'cultrue';
					this.title = '公司文化';
				}else if (str == 'Honor') {
					this.sel3 = 'honor';
					this.title = '荣誉资质';
				}
			},
			selItem(item) {
				this.sel3 = item.name;
				this.title = item.title;
				this.$router.push(item.rou);
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'2',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner2;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getBanner();
			this.getItem();
		}
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.about{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		overflow:hidden;
		.path{
			.margin-top(20);
			.margin-bottom(20);
			i{
				.font-size(20);
			}
			span{
				color: #00A0FF;
			}
		}
		.content{
			.margin-top(50);
			.margin-bottom(50);
			.title{
				text-align: center;
				ul{
					li{
						display: inline-block;
						.padding(10,20,10,20);
						border-right:1px #ddd solid;
						background: #eee;
						.font-size(30);
						text-align: center;
					}
					li:last-child{
						border-right:0px;
					}
					.active{
						background: #00A0FF;
						color: #fff;
					}
				}
				P{
					.margin-top(50);
					.font-size(26);
					color: #00A0FF;
				}
				h3{
					.margin-top(10);
					.font-size(26);
					font-weight: 600;
					.margin-bottom(50);
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/About/About.vue